/** Petites aides de l'interface. */

/** Assemble des classes CSS en ignorant les valeurs fausses. */
export function cx(...classes: (string | false | null | undefined)[]): string {
  return classes.filter(Boolean).join(' ');
}

/** Espace fine insécable, entre un nombre et son unité ou dans les milliers. */
export const ESPACE_FINE = ' ';
/** Espace insécable. */
export const ESPACE_INSECABLE = ' ';

/** Nombre formaté en français (« 1 284 », espace fine insécable). */
export function nombre(valeur: number, decimales = 0): string {
  return new Intl.NumberFormat('fr-FR', {
    maximumFractionDigits: decimales,
    minimumFractionDigits: 0,
  })
    .format(valeur)
    .replace(/\s/g, ESPACE_FINE);
}

/** Accord simple : « 1 carte », « 3 cartes ». */
export function pluriel(n: number, singulier: string, plurielForme = `${singulier}s`): string {
  return `${nombre(n)}${ESPACE_INSECABLE}${Math.abs(n) >= 2 ? plurielForme : singulier}`;
}

/** Vrai si l'événement vient d'un champ de saisie (les raccourcis à lettre seule s'y taisent). */
export function dansUnChamp(cible: EventTarget | null): boolean {
  if (!(cible instanceof HTMLElement)) return false;
  return (
    cible.isContentEditable ||
    cible.closest('input, textarea, select, [contenteditable="true"], .cm-editor') !== null
  );
}
